import now from 'lodash/now';
import { z } from 'zod';

export enum AuditLogCategoryEnum {
  USER = 'USER',
  PRODUCT = 'PRODUCT',
  OFFERING = 'OFFERING',
  RATE = 'RATE',
  QUOTE = 'QUOTE',
  QUOTE_APPROVAL = 'QUOTE_APPROVAL',
  INVOICE = 'INVOICE',
  TENANT = 'TENANT',
  RULE = 'RULE',
  EXPERIENCE_CONFIG = 'EXPERIENCE_CONFIG',
}

export enum AuditLogActionEnum {
  RULE_CREATE = 'RULE_CREATE',
  RULE_UPDATE = 'RULE_UPDATE',
  RULE_ARCHIVE = 'RULE_ARCHIVE',
  EXPERIENCE_CONFIG_UPDATE = 'EXPERIENCE_CONFIG_UPDATE',
}

export const AuditLogSchema = z.object({
  logTimeStamp: z.string(),
  key: z.string(),
  size: z.number(),
});

export type AuditLog = z.infer<typeof AuditLogSchema>;

export const AuditLogRequestSchema = z.object({
  timestamp: z.number().default(() => now()),
  userId: z.string(),
  tenantId: z.string(),
  category: z.enum(AuditLogCategoryEnum),
  action: z.enum(AuditLogActionEnum),
  log: z.string(),
});

export type AuditLogRequest = z.infer<typeof AuditLogRequestSchema>;
